"use strict";

Shopify.theme.jsCartProductPopup = {
    count: 0,
    selected: [],
    init: function init($section) {
        Shopify.theme.jsCartProductPopup = $.extend(this, Shopify.theme.getSectionData($section));
        let $open_button = $('[data-open-product-popup]')
        let $close_button = $('[data-close-product-popup]')
        let $add_to_cart = $section.find(['data-add-to-cart'])
        let $selection_option = $section.find('[data-select-variant]')
        let $continue = $section.find('[data-continue]')
        let $overlay = $('.body-overlay')

        $overlay.on('click', function() {
            Shopify.theme.jsCartProductPopup.close()
        })
        $(document).on('click','[data-open-product-popup]', function() {
            Shopify.theme.jsCartProductPopup.open()
        })

        $close_button.on('click', function() {
            Shopify.theme.jsCartProductPopup.close()
        })

        $selection_option.on('change', function() {
            if ($(this).is(':checked')) {
                Shopify.theme.jsCartProductPopup.count++
                Shopify.theme.jsCartProductPopup.selected.push($(this).val())
            } else {
                let _this1 = this
                Shopify.theme.jsCartProductPopup.count--
                Shopify.theme.jsCartProductPopup.selected = Shopify.theme.jsCartProductPopup.selected.filter(variant => {
                    if (variant != $(_this1).val()) {
                        return variant
                    }
                })
            }
            Shopify.theme.jsCartProductPopup.switchAddToCart()
        })

        $continue.on('click', function() {
            let $section = $('.jsCartProductPopup')
            
            $section.find('.error').addClass('is-hidden').text('Fields must not be empty')
            let message = $section.find('#card_message').val()
            let from = $section.find('#card_from').val()
            console.log(message.trim() == '' || from.trim() == '')
            if(message.trim() == '' || from.trim() == ''){
                $section.find('.error').removeClass('is-hidden')
                return;
            }else{
              $continue.addClass('is-loading')
              function success(){
                  $continue.removeClass('is-loading')
              }
              function err_cb(err){
                  console.log(err)
                  $section.find('.error').removeClass('is-hidden').text(err)
                  $continue.removeClass('is-loading')
              }
              Shopify.theme.jsCartProductPopup.batch_AddToCart(message,from,success,err_cb)
            }


        })


    },
    switchAddToCart: function switchAddToCart() {
        let $section = $('.jsCartProductPopup')
        let $pending = $section.find('[data-pending]')
        let $continue = $section.find('[data-continue]')
        if (Shopify.theme.jsCartProductPopup.count > 0) {
            $pending.addClass('is-hidden')
            $continue.removeClass('is-hidden')
        } else {
            $pending.removeClass('is-hidden')
            $continue.addClass('is-hidden')
        }
    },
    batch_AddToCart: function batch_AddToCart(message,from ,cb,err_cb) {
		
        if (Shopify.theme.jsCartProductPopup.count > 0) {
          let items=[]
          for(let i=0;i<=Shopify.theme.jsCartProductPopup.selected.length-1;i++){
            items.push({
              id:Shopify.theme.jsCartProductPopup.selected[i],
              quantity:1,
              properties:{
                message,
                from
              }
            })
          }
          //dataOBJ = JSON.parse(dataOBJ)
// //           //console.log(dataOBJ)
//             let data = `{"items":[`
//             for (let variant in Shopify.theme.jsCartProductPopup.selected) {
//                 data += `{"id":${Shopify.theme.jsCartProductPopup.selected[variant]},"quantity":1,"properties":{
//                     "message":"${message}","from":"${from}"
//                 }}`
//                 if (variant != Shopify.theme.jsCartProductPopup.count - 1) {
//                     data += ','
//                 }
//             }
//             data += `]}`
//             console.log(data)
            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: {items},
                success: function success(product) {
                   // $add_to_cart.removeClass('is-loading')
                    if(cb){
                    cb()
                    }
                    Shopify.theme.jsCartProductPopup.close()
                    Shopify.theme.jsAjaxCart.updateView();
console.log('DONE')
                    if (Shopify.theme.jsCart) {
                        var _$$ajax;

                        $.ajax((_$$ajax = {
                            dataType: "json",
                            async: false,
                            cache: false
                        }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
                            var cartForm = $(html).find('.cart__form');
                            $('.cart__form').replaceWith(cartForm);

                            if (Shopify.theme_settings.show_multiple_currencies) {
                                convertCurrencies();
                            }
                        }), _$$ajax));
                    }
                },
              error:function error(err){
                console.log(err)
                err = err.responseJSON?err.responseJSON.description: err.statusText 
                err_cb(err)
              }
            })
        }
    },
    open: function open() {
        let $section = $('.jsCartProductPopup')
        $('.body-overlay').fadeIn(200)
        $section.fadeIn(300)

    },
    close: function close() {
        let $section = $('.jsCartProductPopup')
        $section.fadeOut(300)
        $('.body-overlay').fadeOut(200)

    },
    unload: function unload($section) {
        let $open_button = $('[data-open-product-popup]')
        let $close_button = $('[data-close-product-popup]')
        let $add_to_cart = $section.find(['data-add-to-cart'])
        let $selection_option = $section.find('[data-select-variant]')
        $open_button.off('click')
        $close_button.off('click')
        $add_to_cart.off('click')
        $selection_option.prop('checked', false)
    }
};